import type { GetUploadsParams, UploadsResponse } from '@/types/uploads'

import { api } from './client'

export const uploadsApi = {
  getUploads: (params?: GetUploadsParams) =>
    api.get<UploadsResponse>('/uploads', params),
}
